//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalIcon from '@tidal/styles-icons/src/components/tidal-icon.vue';
import { generalClose } from '@tidal/styles-icons';

export default {
    components: {
        tidalIcon,
    },
    props: {
        error: {
            type: [Object, String],
            default: '',
        },
        /** @type {import('vue').PropOptions<import('@tidal/user-middleware').AppMode | null>} */
        appMode: {
            type: Object,
            default: null,
        },
        hideErrorTimeout: {
            type: Number,
            default: 6000,
        },
    },
    data() {
        return {
            /** @type {NodeJS.Timeout | null} */
            timeoutID: null,
            generalClose,
            bounceUp: false,
        };
    },
    mounted() {
        this.autoHideError();
    },
    updated() {
        this.autoHideError();
    },
    methods: {
        hideError() {
            this.bounceUp = true;
            this.$emit('hide-error');
        },
        autoHideError() {
            if (!this.error) {
                return;
            }

            if (this.timeoutID) {
                clearTimeout(this.timeoutID);
            }
            this.timeoutID = setTimeout(this.hideError, this.hideErrorTimeout);
        },
    },
};
